import React, { Component } from "react";
import { connect } from "react-redux";
import { Row, Column } from "react-foundation";
import { Field, formValueSelector, reduxForm, change } from "redux-form";
import ChipsGrid from "components/ChipsGrid";
import validate from "./../validate";
import ImageResolver from "./../../ImageResolver.js";
import { addPreviousPreviews } from "./../../../actions";
import SwitchInput from "../../../components/SwitchInput";
import ThemeButton from "../../../components/ThemeButton";
import SeparatingLine from "../../../components/SeparatingLine";
import FormWrapper from "../../FormWrapper";
import FormHeader from "../../../components/FormHeader";
import { getCompositeDoorColours } from "../../../selectors";
import utils from '../../../utils';
import { updatePreviousSelection } from '../../../actions';

const getBestMatch = (hardwares, selectedColour) => {
    let bestGuessMatch = selectedColour.bestGuessMatch;
    let hardwareIndex = 0;
    if (bestGuessMatch) {
        hardwareIndex = hardwares.findIndex(h => h.name.indexOf(bestGuessMatch) !== -1);
    }
    var hardwareId = hardwares[hardwareIndex] ? hardwares[hardwareIndex].id : hardwares[0].id;
    return hardwareId;
};

const SelectHardware = ({ input, colours, label }) => {
    return (
        <div style={{ marginTop: 20 }}>
            <SwitchInput input={input}>{label}</SwitchInput>
            <ChipsGrid
                chipsPerRow={6}
                colours={colours}
                selectedId={input.value}
                onChange={input.onChange}
            />
        </div>
    );
};

class HardwareForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            DoorKnockerId: null,
            DoorLetterboxId: null,
            Loaded: false
        };
    }

    onFieldChange(name, emptyValue, addPreviousPreview, e, value, oldValue) {
        // if the value is true, the Switch has been re-enabled, so grab the value from State
        if (value === true) {
            value = this.state[name];

            // if the value is empty and the old value isn't "true", it means we've disaled the Switch. Store the old value (selected swatch) in State
        } else if (value === false && oldValue !== true) {
            var newState = {};
            newState[name] = oldValue;
            this.setState(newState);
        }

        // if we have a value, update the previews
        if (value) {
            addPreviousPreview(value);

            // if we don't have a value, update the preview with the empty value
        } else {
            addPreviousPreview(emptyValue);
        }

        // dispatch the change
        setTimeout(() => this.props.dispatch(change("DoorWizard", name, value)), 1);
    }

    componentDidUpdate() {
        let {
            knockers,
            selectedKnocker,
            letterboxes,
            selectedLetterbox,
            selectedColour,
            dispatch,
            addPreviousPreviews,
            imagePreviewsLoaded,
            previousSelection,
            doorStyle
        } = this.props;

        let updateState = false;

        // if we don't have a knocker, and we have previews, and we haven't loaded those already
        if (!selectedKnocker.id && imagePreviewsLoaded && !this.state.Loaded && doorStyle.canHaveKnocker) {
            // and we have knockers in our data
            if (knockers.length > 0) {
                var knockerId = utils.findHardwareByColour(knockers, previousSelection.DoorCompositeHandleColour) || getBestMatch(knockers, selectedColour);
                // set the original knocker
                dispatch(change("DoorWizard", "DoorKnockerId", knockerId));
                addPreviousPreviews({ extraId: knockerId }, [5]);
                updateState = true;
            }
        }

        // same as above with letterbox
        if (!selectedLetterbox.id && imagePreviewsLoaded && !this.state.Loaded && doorStyle.canHaveLetterbox) {
            if (letterboxes.length > 0) {
                // do somthing
                var letterboxId = utils.findHardwareByColour(letterboxes, previousSelection.DoorCompositeHandleColour) || getBestMatch(letterboxes, selectedColour);
                dispatch(change("DoorWizard", "DoorLetterboxId", letterboxId));
                addPreviousPreviews({ extraId: letterboxId }, [6]);
                updateState = true;
            }
        }

        if (updateState) this.setState({ Loaded: true });
    }

    onSubmit(values) {

        this.props.onSubmit(values);
    }

    render() {

        return (
            <form className="HardwareForm composite" onSubmit={this.props.handleSubmit(this.onSubmit.bind(this))}            >
                <FormHeader title={"Hardware"} subtitle={"Add your accessories to match your handle."} />

                <SeparatingLine />

                <FormWrapper>
                    <Row collapseOnSmall uncollapseOnMedium>
                        <Column pushOnLarge={6} large={6}>
                            <ImageResolver
                                query={{
                                    productId: this.props.doorTypeId,
                                    styleid: this.props.doorStyleId
                                }}
                                filters={[
                                    { extraId: this.props.selectedKnocker.id },
                                    { extraId: this.props.selectedLetterbox.id }
                                ]}
                            />
                        </Column>
                        <Column pullOnLarge={6} large={6} style={{ marginTop: 10 }}>
                            {this.props.showDoorKnockerChoice && (
                                <Row isColumn>
                                    <Field
                                        name="DoorKnockerId"
                                        component={SelectHardware}
                                        colours={this.props.knockers}
                                        onChange={this.onFieldChange.bind(
                                            this,
                                            "DoorKnockerId",
                                            this.props.noKnocker.id,
                                            val =>
                                                this.props.addPreviousPreviews({ extraId: val }, [
                                                    5
                                                ])
                                        )}
                                        label="Include a knocker"
                                    />
                                </Row>
                            )}
                            {this.props.showDoorLetterboxChoice && (
                                <Row isColumn>
                                    <Field
                                        name="DoorLetterboxId"
                                        component={SelectHardware}
                                        colours={this.props.letterboxes}
                                        onChange={this.onFieldChange.bind(
                                            this,
                                            "DoorLetterboxId",
                                            this.props.noLetterbox.id,
                                            val =>
                                                this.props.addPreviousPreviews({ extraId: val }, [
                                                    6
                                                ])
                                        )}
                                        label="Include a letterbox"
                                    />
                                </Row>
                            )}
                        </Column>
                    </Row>
                </FormWrapper>
                <div className="button-panel">
                    <SeparatingLine />
                    <button className="button back" type="button" onClick={this.props.previousPage}>
                        Back
                    </button>
                    <ThemeButton className="next">Next</ThemeButton>
                </div>
            </form>
        );
    }
}

const mapStateToProps = state => {
    const valueSelector = formValueSelector("DoorWizard");
    const doorKnockerId = valueSelector(state, "DoorKnockerId");
    const doorLetterboxId = valueSelector(state, "DoorLetterboxId");
    const doorTypeId = valueSelector(state, "DoorTypeId") || 8;
    const doorStyleId = valueSelector(state, "DoorStyleId") || 168;
    const exteriorColourId = valueSelector(state, "DoorExteriorColourId");

    let knockers = state.Door.Options.extras.filter(e => /knocker/i.test(e.extraGroupName));
    knockers.sort(utils.sortExtraByRank);
    let letterboxes = state.Door.Options.extras.filter(e => /letterbox/i.test(e.extraGroupName));
    letterboxes.sort(utils.sortExtraByRank);

    const noKnocker = knockers.filter(e => /\bno\b/i.test(e.name))[0];
    const noLetterbox = letterboxes.filter(e => /\bno\b/i.test(e.name))[0];

    let selectedKnocker = {};

    if (doorKnockerId) selectedKnocker = knockers.filter(c => c.id === doorKnockerId)[0] || {};

    let selectedLetterbox = {};

    if (doorLetterboxId)
        selectedLetterbox = letterboxes.filter(c => c.id === doorLetterboxId)[0] || {};

    knockers = knockers.filter(e => !/\bno\b/i.test(e.name));
    letterboxes = letterboxes.filter(e => !/\bno\b/i.test(e.name));

    const exteriorColours = getCompositeDoorColours(state, "external");
    const selectedColour = exteriorColours.filter(c => c.id === exteriorColourId)[0];

    const doorStyle = state.Door.Styles.filter(s=>s.isPrincipalStyle === true).find(s => s.id ===doorStyleId) || {};

    return {
        selectedColour,
        knockers,
        letterboxes,
        selectedKnocker,
        selectedLetterbox,
        noKnocker,
        noLetterbox,
        doorTypeId,
        doorStyleId,
        doorStyle,
        imagePreviewsLoaded: state.PreviewImages && state.PreviewImages.length > 0,
        previousSelection: state.PreviousSelection
    };
};

export default connect(mapStateToProps, { addPreviousPreviews, updatePreviousSelection })(
    reduxForm({
        form: "DoorWizard",
        destroyOnUnmount: false,
        keepDirtyOnReinitialize: true,
        enableReinitialize: true,
        validate,
        initialValues: {
            // DoorKnocker: true,
            // DoorLetterbox: true
        }
    })(HardwareForm)
);



// WEBPACK FOOTER //
// ./src/containers/DoorForm/composite/HardwareForm.js